import { AppProgressProvider, useRouter } from "./chunk-IABMTV44.js";
import { PagesProgressProvider } from "./chunk-5UIML55L.js";
import "./chunk-G56CNV7G.js";
// src/index.ts
import { useProgress, Progress, Bar, Peg, Spinner, SpinnerIcon } from "@bprogress/react";
export { AppProgressProvider, Bar, PagesProgressProvider, Peg, Progress, Spinner, SpinnerIcon, useProgress, useRouter };
//# sourceMappingURL=index.js.map